export default __webpack_public_path__ + "static/media/thingsboard-architecture.55c343ac.svg";